module.exports = __webpack_public_path__ + "img/single-Item.cadf055b.png";